<template>
  <div id="home">
    <div class="nav-menu" @click="isShow = !isShow">
      <div class="header">
        <img
          @click="back"
          title="Back"
          style="cursor: pointer"
          src="../assets/icon/back.png"
        />
      </div>
      <el-menu
        class="el-menu-vertical-demo"
        background-color="#27333d"
        text-color="#eeeeef"
        v-if="this.projectInfo"
      >
        <el-menu-item index="1" :title="this.projectInfo.groupCustomer_name">
          <span class="icon">
            <img src="../assets/icon/one.png" alt="" />
          </span>
          <span class="title" v-if="isShow">
            <span>
              {{ this.projectInfo.groupCustomer_name }}
            </span>
          </span>
        </el-menu-item>
        <el-menu-item index="2" :title="this.projectInfo.channel">
          <span class="icon">
            <img src="../assets/icon/channel.png" alt="" />
          </span>
          <span class="title" v-if="isShow">
            <span>
              {{ this.projectInfo.channel }}
            </span>
          </span>
        </el-menu-item>
        <el-menu-item index="3" :title="this.projectInfo.city">
          <span class="icon">
            <img src="../assets/icon/three.png" alt="" />
          </span>
          <span class="title" v-if="isShow">
            <span>
              {{
                isEmpty(this.projectInfo.city)
                  ? ""
                  : this.projectInfo.city.length >= 20
                  ? this.projectInfo.city.substring(0, 20) + "..."
                  : this.projectInfo.city
              }}
            </span>
          </span>
        </el-menu-item>
        <el-menu-item index="4" :title="this.projectInfo.locationType">
          <span class="icon">
            <img src="../assets/icon/two.png" alt="" />
          </span>
          <span class="title" v-if="isShow"
            ><span>
              {{ this.projectInfo.locationType }}
            </span>
          </span>
        </el-menu-item>
        <el-menu-item index="4">
          <span class="icon">
            <img src="../assets/icon/four.png" alt="" />
          </span>
          <span class="title" v-if="isShow">
            <span> Closure </span>
          </span>
        </el-menu-item>
        <el-menu-item index="5" :title="this.mpsa">
          <span class="icon">
            <img src="../assets/icon/money.png" alt="" />
          </span>
          <span class="title" v-if="isShow">
            <span>
              {{ this.mpsa }}
            </span>
          </span>
        </el-menu-item>
        <el-menu-item index="6" :title="this.projectInfo.strdates">
          <span class="icon">
            <img src="../assets/icon/nine.png" alt="" />
          </span>
          <span class="title" v-if="isShow">
            <span>
              {{ this.projectInfo.strdates }}
            </span>
          </span>
        </el-menu-item>
        <el-menu-item index="7" :title="this.projectInfo.closeReason">
          <span class="icon">
            <img src="../assets/icon/closereason.png" alt="" />
          </span>
          <span class="title" v-if="isShow">
            <span>
              {{ this.projectInfo.closeReason }}
            </span>
          </span>
        </el-menu-item>
      </el-menu>
      <div class="ssBtn" @click="fn">
        <el-icon v-if="isShow" class="el-icon-arrow-left"></el-icon>
        <el-icon v-if="!isShow" class="el-icon-arrow-right"></el-icon>
      </div>
    </div>
    <div class="main" :style="{ height: pdfshow ? '1200px' : 'auto' }">
      <div class="wrapper">
        <div class="btns">
          <div class="addContent">
            <span class="left">{{ this.projectInfo.nameEN }}</span>
            <span class="minleft">{{ this.projectInfo.nameCN }}</span>
          </div>
          <div class="right" v-if="isapprove">
            <el-popover width="450" v-model="visibleA">
              <p style="display: flex; flex-direction: column">
                <b
                  >Comments<b style="color: rgb(169, 169, 169)"
                    >(You can comment here if needed)</b
                  ></b
                >
                <el-input
                  style="
                    margin: 10px 0;
                    word-break: keep-all;
                    word-wrap: break-word;
                  "
                  placeholder="You can comment here if needed"
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  v-model="textareaapprove"
                  @keyup.enter.native="textareaappHanlder"
                  @input="textareaappHanlderRest"
                >
                </el-input>
              </p>
              <div style="text-align: right; margin: 0">
                <el-button
                  type="success"
                  size="mini"
                  :disabled="isDisable"
                  @click="postApproval(1, textareaapprove)"
                  >Submit
                </el-button>
              </div>
              <el-button
                style="margin-right: 30px"
                slot="reference"
                type="success"
                >Approve</el-button
              >
            </el-popover>
            <el-popover width="450" v-model="visibleT">
              <p style="display: flex; flex-direction: column">
                <b>Reject Comments</b>
                <el-input
                  style="
                    margin: 10px 0;
                    word-break: keep-all;
                    word-wrap: break-word;
                  "
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  v-model="textarea"
                  @keyup.enter.native="textareaHanlder"
                  @input="textareaHanlderRest"
                >
                </el-input>
              </p>
              <div style="text-align: right; margin: 0">
                <el-button
                  type="danger"
                  size="mini"
                  :disabled="isDisable"
                  @click="postApproval(2, textarea)"
                  >Submit
                </el-button>
              </div>
              <el-button slot="reference" type="danger" plain>Reject</el-button>
            </el-popover>
          </div>
        </div>
        <transition name="el-zoom-in-top">
          <div v-if="pack">
            <div class="top" v-if="isapprove">
              <div class="process">
                <div class="line">
                  <el-progress
                    type="line"
                    color="#ff9700"
                    :percentage="percentage"
                    :stroke-width="2"
                    :format="format"
                  ></el-progress>
                </div>
                <div class="points">
                  <div class="pointContent">
                    <template v-for="i in process">
                      <div :key="i.order" style="text-align: center">
                        <p
                          :class="[
                            tableDatared && projectInfo.employee == i.employee
                              ? 'rj'
                              : i.approvalResult == '3902'
                              ? 'tg'
                              : i.approvalResult == '3901'
                              ? 'common'
                              : 'common'
                          ]"
                        ></p>
                        <p
                          style="
                            font-weight: 600;
                            position: absolute;
                            top: 45px;
                            left: -35px;
                            width: 120px;
                          "
                        >
                          {{ i.name }}
                        </p>
                        <p
                          v-if="i.approvalResult == '3902'"
                          style="
                            font-weight: 600;
                            color: #75777a;
                            position: absolute;
                            top: 95px;
                            left: -35px;
                            width: 100px;
                          "
                        >
                          {{ i.approveDate }}
                        </p>
                        <div
                          v-if="
                            tableData.length > 0 &&
                              projectInfo.employee == i.employee
                          "
                          style="
                            display: flex;
                            flex-direction: row;
                            position: absolute;
                            top: 95px;
                            left: 5px;
                          "
                        >
                          <el-popover
                            placement="bottom"
                            trigger="click"
                            v-model="visible"
                          >
                            <el-table
                              class="project-table"
                              :data="tableData"
                              max-height="400"
                              style="width: 600px"
                              :show-header="false"
                            >
                              <el-table-column style="border: 2">
                                <template slot-scope="scope">
                                  <div
                                    v-if="scope.row.groupDetail"
                                    style="margin-left: 30px"
                                  >
                                    <p class="fontbold">
                                      {{ scope.row.createDateGroup }}
                                    </p>
                                    <p class="fontbold">
                                      【Rejected by
                                      {{ scope.row.comment_name }}】
                                    </p>
                                    <div
                                      v-for="(item, index) in scope.row
                                        .groupDetail"
                                      :key="index + '_a'"
                                    >
                                      <p
                                        style="
                                          word-break: keep-all;
                                          word-wrap: break-word;
                                        "
                                      >
                                        &nbsp;&nbsp;●{{ item.comment }}
                                      </p>
                                    </div>
                                    <br />
                                    <p class="fontbold">
                                      【Answered by
                                      {{ scope.row.anwser_name }}】
                                    </p>
                                    <div
                                      v-for="(item, index) in scope.row
                                        .groupDetail"
                                      :key="index + '_b'"
                                    >
                                      <p
                                        style="
                                          word-break: keep-all;
                                          word-wrap: break-word;
                                        "
                                      >
                                        &nbsp;&nbsp;●{{ item.answer }}
                                      </p>
                                    </div>
                                  </div>
                                  <div
                                    v-if="
                                      scope.row.groupDetail &&
                                        scope.row.groupUpdate
                                    "
                                    style="margin-left: 30px"
                                  >
                                    <br />
                                    <p class="fontbold">
                                      【Updated by {{ scope.row.update_name }}】
                                    </p>
                                    <div
                                      v-for="(item, index) in scope.row
                                        .groupUpdate"
                                      :key="index + '_c'"
                                    >
                                      <p
                                        style="
                                          word-break: keep-all;
                                          word-wrap: break-word;
                                        "
                                      >
                                        &nbsp;&nbsp;{{ item.comment }}
                                      </p>
                                    </div>
                                  </div>
                                  <div
                                    v-if="
                                      !scope.row.groupDetail &&
                                        scope.row.groupUpdate
                                    "
                                    style="margin-left: 30px"
                                  >
                                    <p class="fontbold">
                                      {{ scope.row.createDateGroup }}
                                    </p>
                                    <p class="fontbold">
                                      【Updated by {{ scope.row.update_name }}】
                                    </p>
                                    <div
                                      v-for="(item, index) in scope.row
                                        .groupUpdate"
                                      :key="index + '_d'"
                                    >
                                      <p
                                        style="
                                          word-break: keep-all;
                                          word-wrap: break-word;
                                        "
                                      >
                                        &nbsp;&nbsp;{{ item.comment }}
                                      </p>
                                    </div>
                                  </div>
                                  <div
                                    v-if="scope.row.approveDetail"
                                    style="margin-left: 30px"
                                  >
                                    <p
                                      class="fontbold"
                                      style="margin-left: 5px; margin-top: 5px"
                                    >
                                      {{ scope.row.createDateGroup }}
                                    </p>
                                    <p class="fontbold">
                                      【Approved by
                                      {{ scope.row.update_name }}】
                                    </p>
                                    <div
                                      v-for="(item, index) in scope.row
                                        .approveDetail"
                                      :key="index + '_e'"
                                    >
                                      <p
                                        style="
                                          word-break: keep-all;
                                          word-wrap: break-word;
                                        "
                                      >
                                        &nbsp;&nbsp;●{{ item.comment }}
                                      </p>
                                    </div>
                                  </div>
                                </template>
                              </el-table-column>
                            </el-table>
                            <img
                              src="../assets/icon/info.png"
                              alt=""
                              :style="{
                                marginLeft: '8px',
                                marginTop: i.approveDate ? '20px' : 0,
                                width: '20px'
                              }"
                              slot="reference"
                            />
                          </el-popover>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="top" v-if="!isapprove">
              <div class="process">
                <div class="line">
                  <el-progress
                    type="line"
                    color="#ff9700"
                    :percentage="percentage"
                    :stroke-width="2"
                    :format="format"
                  ></el-progress>
                </div>
                <div class="points">
                  <div class="pointContent">
                    <template v-for="i in process">
                      <div :key="i.order" style="text-align: center">
                        <p
                          :class="[
                            tableDatared && projectInfo.employee == i.employee
                              ? 'rj'
                              : i.approvalResult == '3902'
                              ? 'tg'
                              : i.approvalResult == '3901'
                              ? 'common'
                              : 'common'
                          ]"
                        ></p>
                        <p
                          style="
                            font-weight: 600;
                            position: absolute;
                            top: 45px;
                            left: -35px;
                            width: 120px;
                          "
                        >
                          {{ i.name }}
                        </p>
                        <p
                          v-if="i.approvalResult == '3902'"
                          style="
                            font-weight: 600;
                            color: #75777a;
                            position: absolute;
                            top: 95px;
                            left: -35px;
                            width: 100px;
                          "
                        >
                          {{ i.approveDate }}
                        </p>
                        <div
                          v-if="
                            (tableData.length > 0 &&
                              projectInfo.employee == i.employee) ||
                              (tableData.length > 0 && isadmin && i.order == 1)
                          "
                          style="
                            display: flex;
                            flex-direction: row;
                            position: absolute;
                            top: 95px;
                            left: 5px;
                          "
                        >
                          <el-popover
                            placement="bottom"
                            trigger="click"
                            v-model="visible"
                          >
                            <el-table
                              class="project-table"
                              :data="tableData"
                              max-height="400"
                              style="width: 600px"
                              :show-header="false"
                            >
                              <el-table-column style="border: 2">
                                <template slot-scope="scope">
                                  <div
                                    v-if="scope.row.groupDetail"
                                    style="margin-left: 30px"
                                  >
                                    <p class="fontbold">
                                      {{ scope.row.createDateGroup }}
                                    </p>
                                    <p class="fontbold">
                                      【Rejected by
                                      {{ scope.row.comment_name }}】
                                    </p>
                                    <div
                                      v-for="(item, index) in scope.row
                                        .groupDetail"
                                      :key="index + '_f'"
                                    >
                                      <p
                                        style="
                                          word-break: keep-all;
                                          word-wrap: break-word;
                                        "
                                      >
                                        &nbsp;&nbsp;●{{ item.comment }}
                                      </p>
                                    </div>
                                    <br />
                                    <p class="fontbold">
                                      【Answered by
                                      {{ scope.row.anwser_name }}】
                                    </p>
                                    <div
                                      v-for="(item, index) in scope.row
                                        .groupDetail"
                                      :key="index + '_g'"
                                    >
                                      <p
                                        style="
                                          word-break: keep-all;
                                          word-wrap: break-word;
                                        "
                                      >
                                        &nbsp;&nbsp;●{{ item.answer }}
                                      </p>
                                    </div>
                                  </div>
                                  <div
                                    v-if="
                                      scope.row.groupDetail &&
                                        scope.row.groupUpdate
                                    "
                                    style="margin-left: 30px"
                                  >
                                    <br />
                                    <p class="fontbold">
                                      【Updated by {{ scope.row.update_name }}】
                                    </p>
                                    <div
                                      v-for="(item, index) in scope.row
                                        .groupUpdate"
                                      :key="index + '_h'"
                                    >
                                      <p
                                        style="
                                          word-break: keep-all;
                                          word-wrap: break-word;
                                        "
                                      >
                                        &nbsp;&nbsp;{{ item.comment }}
                                      </p>
                                    </div>
                                  </div>
                                  <div
                                    v-if="
                                      !scope.row.groupDetail &&
                                        scope.row.groupUpdate
                                    "
                                    style="margin-left: 30px"
                                  >
                                    <p class="fontbold">
                                      {{ scope.row.createDateGroup }}
                                    </p>
                                    <p class="fontbold">
                                      【Updated by {{ scope.row.update_name }}】
                                    </p>
                                    <div
                                      v-for="(item, index) in scope.row
                                        .groupUpdate"
                                      :key="index + '_i'"
                                    >
                                      <p
                                        style="
                                          word-break: keep-all;
                                          word-wrap: break-word;
                                        "
                                      >
                                        &nbsp;&nbsp;{{ item.comment }}
                                      </p>
                                    </div>
                                  </div>
                                  <div
                                    v-if="scope.row.approveDetail"
                                    style="margin-left: 30px"
                                  >
                                    123
                                    <p
                                      class="fontbold"
                                      style="margin-left: 5px; margin-top: 5px"
                                    >
                                      {{ scope.row.createDateGroup }}
                                    </p>
                                    <p class="fontbold">
                                      【Approved by
                                      {{ scope.row.update_name }}】
                                    </p>
                                    <div
                                      v-for="(item, index) in scope.row
                                        .approveDetail"
                                      :key="index + '_j'"
                                    >
                                      <p
                                        style="
                                          word-break: keep-all;
                                          word-wrap: break-word;
                                        "
                                      >
                                        &nbsp;&nbsp;●{{ item.comment }}
                                      </p>
                                    </div>
                                  </div>
                                </template>
                              </el-table-column>
                            </el-table>
                            <img
                              src="../assets/icon/info.png"
                              alt=""
                              :style="{
                                marginLeft: '8px',
                                marginTop: i.approveDate ? '20px' : 0,
                                width: '20px'
                              }"
                              slot="reference"
                            />
                          </el-popover>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="center" v-if="isapprove">
              <div class="title">
                <div style="width: 400px">
                  <span v-if="!!pieData && pieData.length > 0"
                    >Closure Actual By Quarter:</span
                  >
                </div>
                <div style="width: 900px; margin-bottom: 10px">
                  <span v-if="!!centerRightValue">POS Closure Process:</span>
                </div>
              </div>
              <div id="txPic"></div>
              <div class="linePic">
                <template v-for="(v, k) in centerRightValue">
                  <div class="item" :style="{ zIndex: v.order }" :key="v.order">
                    <div
                      :style="{ width: v.width, backgroundColor: v.bg }"
                      style="
                        height: 44px;
                        color: #bcc3cd;
                        font-size: 12px;
                        border-radius: 22px;
                        line-height: 44px;
                        text-align: right;
                        padding-right: 40px;
                        border: 2px solid #b6bdc8;
                      "
                    >
                      <div :class="v.cName">
                        <span
                          >{{ k.charAt(0).toUpperCase() + k.slice(1) }}:
                          {{ v.showContent }}</span
                        >
                        <img :src="v.img" alt="" />
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div class="table">
              <div class="title">POS DETAILS</div>
              <div class="table">
                <div class="content">
                  <div class="row">
                    <template>
                      <p>
                        <span class="txt"> POS Code: </span>
                        <span class="val">
                          {{ this.projectInfo.posCode }}
                        </span>
                      </p>
                      <p>
                        <span class="txt"> Store Format: </span>
                        <span class="val">
                          {{ this.projectInfo.storeFormat }}
                        </span>
                      </p>
                      <p>
                        <span class="txt"> Fixture Owner: </span>
                        <span class="val">
                          {{ this.projectInfo.fixtureOwner }}
                        </span>
                      </p>
                    </template>
                  </div>
                  <div class="row">
                    <template>
                      <p>
                        <span class="txt"> Operation Period: </span>
                        <span class="val">
                          {{
                            this.projectInfo.operationPeriod == 0
                              ? "0~1"
                              : this.projectInfo.operationPeriod == 1
                              ? "1~2"
                              : this.projectInfo.operationPeriod == 2
                              ? "2~3"
                              : ">3"
                          }}
                          years
                        </span>
                      </p>
                      <p>
                        <span class="txt"> First Open Date: </span>
                        <span class="val">
                          {{ this.projectInfo.stropeningDate }}
                        </span>
                      </p>
                      <p>
                        <span class="txt"> Closure Apply Date: </span>
                        <span class="val">
                          {{ this.projectInfo.strclosureDate }}
                        </span>
                      </p>
                    </template>
                  </div>
                  <div class="row">
                    <template>
                      <p>
                        <span class="txt"> Closure MPSA(K): </span>
                        <span class="val">
                          {{ this.projectInfo.mpsA_Now }} K
                        </span>
                      </p>
                      <p>
                        <span class="txt"> Close Reason: </span>
                        <span class="val">
                          {{ this.projectInfo.closeReason }}
                        </span>
                      </p>
                      <p>
                        <span class="txt"> Detail Reason: </span>
                        <span class="val">
                          {{ this.projectInfo.detailreason }}
                        </span>
                      </p>
                    </template>
                  </div>
                  <div class="row">
                    <template>
                      <p>
                        <span class="txt"> Remark: </span>
                        <span class="val">
                          {{ this.projectInfo.remark }}
                        </span>
                      </p>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div style="width: 100%; text-align: center" v-if="pdfshow">
              <span
                style="
                  border-radius: 0 0 38px 38px;
                  margin: 0 auto;
                  display: block;
                  width: 76px;
                  height: 12px;
                  font-size: 12px;
                  line-height: 12px;
                  cursor: pointer;
                  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
                "
                @click="packclick()"
              >
                <el-icon class="el-icon-arrow-down" v-if="!pack"></el-icon>
                <el-icon class="el-icon-arrow-up" v-if="pack"></el-icon>
              </span>
            </div>
          </div>
        </transition>

        <div class="bottom" v-if="pdfshow">
          <div class="img" @click="packclick()" style="width:100%">
            <pdf ref="pdf" v-for="i in numPages" :key="i" :src="src" :page="i">
            </pdf>
          </div>
        </div>
        <div class="dialog" v-if="isSp">
          <div
            class="txt"
            style="width: 360px; text-align: left; margin: 0 auto 10px"
          >
            {{ alertmsg }}<br /><br />It will jump to the next project code in
            {{ timeNum }}
            seconds...
          </div>
          <div class="time" style="font-size: 80px">
            {{ timeNum }}
          </div>
          <div class="btns">
            <el-button size="small" @click="intervalButtom(2)">
              Next Project <i class="el-icon-right el-icon--right"></i
            ></el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pdf from "vue-pdf";
import footD from "@/data/adidas";
import onePic from "../assets/icon/one-line.png";
import twoPic from "../assets/icon/two-line.png";
import threePic from "../assets/icon/three-line.png";
import fourPic from "../assets/icon/four-line.png";
import twoImg from "../assets/icon/one.png";
import threeImg from "../assets/icon/three.png";
import fourImg from "../assets/icon/two.png";
import fiveImg from "../assets/icon/four.png";
import sixImg from "../assets/icon/money.png";
import sevenImg from "../assets/icon/floor.png";
import eightImg from "../assets/icon/five.png";
import nineImg from "../assets/icon/six.png";
import tenImg from "../assets/icon/seven.png";
import elevenImg from "../assets/icon/nine.png";
export default {
  components: {
    pdf
  },
  data() {
    return {
      pack: true,
      pieData: [],
      footData: [],
      myChart: null,
      timer: null,
      isSp: false,
      timeNum: 3,
      isShow: true,
      isDisable: false,
      baseurl: "/static/Attachment/",
      url: "",
      src: undefined,
      numPages: undefined,
      projectInfo: {
        groupCustomer_name: ""
      },
      projectInfoStreetEN: null,
      space: null,
      mpsa: null,
      formats: null,
      visible: false,
      visibleA: false,
      visibleT: false,
      process: null,
      centerRight: null,
      textareaapprove: "●",
      textarea: "●",
      tableData: [],
      tableDatared: false,
      page: "",
      isapprove: false,
      middlePageNum: null,
      alertmsg: null,
      isadmin: false,
      iconList: [
        twoImg,
        threeImg,
        fourImg,
        fiveImg,
        sixImg,
        sevenImg,
        eightImg,
        nineImg,
        tenImg,
        elevenImg
      ],
      pdfshow: false
    };
  },
  computed: {
    allPoints() {
      if (!!this.process) {
        return this.process.length;
      }
    },
    finishPoints() {
      let tmp = 0;
      if (this.process) {
        this.process.forEach(a => {
          if (a.approvalResult == "3902") {
            tmp++;
          }
        });
      }
      return tmp;
    },
    percentage() {
      let tmp = 0;
      if (this.allPoints > 0) {
        tmp = (this.finishPoints / (this.allPoints - 1)) * 100;
      }
      return tmp;
    },
    centerRightValue() {
      if (this.centerRight) {
        let tmp = JSON.parse(JSON.stringify(this.centerRight));
        if (tmp.target != null && tmp.actual != null) {
          if (!(tmp.target.value == null || tmp.actual.value == null)) {
            let countTarget = tmp.target.value;
            let countActual = tmp.actual.value;
            let allVall =
              countTarget >= countActual ? countTarget : countActual;

            let arr1 = [onePic, fourPic];
            let arr2 = ["transparent", "#6b7b91"];
            let arr3 = ["onePic", "twoPic"];
            if (countTarget == countActual) {
              let num = 0;
              for (let k in tmp) {
                tmp[k].img = arr1[num];
                tmp[k].bg = arr2[num];
                tmp[k].cName = arr3[num];
                tmp[k].width = 900 + "px";
                tmp[k].showContent = tmp[k].value;
                num++;
              }
            } else {
              for (let k in tmp) {
                if (tmp[k].value == allVall) {
                  tmp[k].img = arr1[0];
                  tmp[k].bg = arr2[0];
                  tmp[k].cName = arr3[0];
                  tmp[k].width = 900 + "px";
                  //tmp[k].order=1;
                } else {
                  tmp[k].img = arr1[1];
                  tmp[k].bg = arr2[1];
                  tmp[k].cName = arr3[1];
                  if (k == "actual") {
                    tmp[k].width = (tmp[k].value / allVall) * 900 + "px";
                  } else {
                    tmp[k].width = 720 + "px";
                  }
                  //tmp[k].order=10;
                }
                tmp[k].showContent = tmp[k].value;
              }
            }
            if (tmp.target.value == 0) {
              tmp.target.showContent = "TGT is WIP";
            }

            return tmp;
          }
        }
      }
    }
  },
  methods: {
    isEmpty(obj) {
      if (typeof obj == "undefined" || obj == null || obj == "") {
        return true;
      } else {
        return false;
      }
    },
    chartResize() {
      if (this.myChart) {
        this.myChart.resize();
      }
    },
    initChart() {
      var chartDom = document.getElementById("txPic");
      //console.log(chartDom);
      if (chartDom != null) {
        this.myChart = this.$echarts.init(chartDom);
        let option = {
          // tooltip: {
          //   trigger: "item",
          //   formatter: function (data) {
          //     var res =
          //       data.name + " : " + data.percent.toFixed(0) + "%; " + data.value;
          //     return res;
          //   },
          // },
          legend: {
            orient: "vertical",
            left: "left",
            show: false
          },
          series: [
            {
              type: "pie",
              radius: ["40%", "60%"],
              center: ["50%", "60%"],
              data: this.pieData,
              label: {
                normal: {
                  formatter: function(data) {
                    return (
                      data.name +
                      " : " +
                      data.percent.toFixed(0) +
                      "%; " +
                      data.value
                    );
                  },
                  textStyle: { fontSize: "16", fontWeight: "bolder" }
                }
              }
              // emphasis: {
              //   itemStyle: {
              //     shadowBlur: 10,
              //     shadowOffsetX: 0,
              //     shadowColor: "rgba(0, 0, 0, 0.5)",
              //   },
              // },
            }
          ]
        };
        this.myChart.setOption(option);
      }
    },
    textareaappHanlder() {
      this.textareaapprove += "●";
    },
    textareaHanlder() {
      this.textarea += "●";
    },
    textareaHanlderRest() {
      if (this.textarea.length == 0) {
        this.textarea = "●";
      }
    },
    textareaappHanlderRest() {
      if (this.textareaapprove.length == 0) {
        this.textareaapprove = "●";
      }
    },
    fn() {
      this.isShow = !isShow;
    },
    //返回上级页面
    back() {
      this.$router.go(-1);
    },
    format() {
      return "";
    },
    // 获取项目信息
    bindData(projectID) {
      this.isDisable = false;
      var approval = 0;
      if (!this.isapprove) {
        approval = 1;
      }

      this.$api
        .get("/Login/IsAdmin/", {}, res => {})
        .then(res => {
          this.isadmin = res.data;
        });

      this.$api
        .get("/Project/GetClusoreInfo", {
          projectID: projectID,
          approval: approval
        })
        .then(res => {
          if (res.data.status == true) {
            this.projectInfo = res.data.content;
            this.mpsa = this.projectInfo.mpsA_Now + "K";
          } else {
            if (res.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else if (res.data.message == "不存在的项目") {
              this.$router.go(-1);
            } else {
              //console.log("bind");
              this.$message({
                type: "error",
                message: res.data.message
              });
              return false;
            }
          }
        });
    },
    // 获取审批人信息
    bindApprovalData(projectID) {
      this.$api
        .get("/Project/GetApprovalInfos", {
          projectID: projectID
        })
        .then(res1 => {
          if (res1.data.status == true) {
            this.process = res1.data.content;
          } else {
            if (res1.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {
              //console.log("bindapproldata");
              this.$message({
                type: "error",
                message: res1.data.message
              });
              return false;
            }
          }
        });
    },
    // 获取审批历史信息
    bindApprovalHistoryData(projectID) {
      this.$api
        .get("/Project/GetApprovalHistoryInfos", {
          projectID: projectID
        })
        .then(res5 => {
          if (res5.data.status == true) {
            this.tableData = res5.data.content != null ? res5.data.content : [];
            if (this.tableData.length != 0) {
              for (var i = 0; i < this.tableData.length; i++) {
                if (this.tableData[i].groupDetail != null) {
                  this.tableDatared = true;
                }
              }
            }
          } else {
            if (res5.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {
              //console.log("bindApprovalHistoryData");
              this.$message({
                type: "error",
                message: res5.data.message
              });
              return false;
            }
          }
        });
    },
    // 获取金字塔信息
    bindClosurePyramidData(projectID) {
      this.$api
        .get("/List/GetClosurePyramidData", { projectID: projectID })
        .then(res4 => {
          if (res4.data.status == true) {
            this.pieData = res4.data.content;
            this.pieData.forEach((a, i) => {
              var o = {
                color: `rgba(70, 89, 117,${0.15 + 0.15 * (i + 1)})`
              };
              a.itemStyle = o;
            });
            this.initChart();
          } else {
            if (res4.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {
              //console.log("bindClosurePyramidData");
              this.$message({
                type: "error",
                message: res4.data.message
              });
              return false;
            }
          }
        });
    },
    // 获取开店进度信息
    bindApprovalProcess(projectID) {
      this.$api
        .get("/Project/GetClusoreProcess", {
          projectID: projectID
        })
        .then(res6 => {
          if (res6.data.status == true) {
            this.centerRight = res6.data.content;
          } else {
            if (res6.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {
              //console.log("bindApprovalProcess");
              this.$message({
                type: "error",
                message: res6.data.message
              });
              return false;
            }
          }
        });
    },
    getNumPages(pdfUrl) {
      let loadingTask = pdf.createLoadingTask(pdfUrl);
      this.src = loadingTask;
      loadingTask.promise
        .then(pdf => {
          this.numPages = pdf.numPages;
        })
        .catch(err => {
          console.error("pdf 加载失败", err);
        });
    },
    // 获取附件名
    bindAttachment(projectID) {
      this.$api
        .get("/Project/GetApprovalAttachment", {
          projectID: projectID
        })
        .then(res3 => {
          if (res3.data.status == true) {
            if (!this.isEmpty(res3.data.content)) {
              this.pdfshow = true;
              this.url = this.baseurl + res3.data.content + ".pdf";
            }
          } else {
            if (res3.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {
              //console.log("bindAttachment");
              this.$message({
                type: "error",
                message: res3.data.message
              });
              return false;
            }
          }
        });
    },
    // 调用审批接口
    postApproval(operate, comment) {
      this.isDisable = true; //点击后禁用该按钮
      if (operate == 2) {
        if (comment == "●") {
          this.$message({
            type: "error",
            message: "Reject commonts is required."
          });
          return;
        }
        this.textarea = "●";
        comment = comment
          .split("\n")
          .join("<br>")
          .replace(/●/g, "");
      } else if (operate == 1) {
        if (comment == "●") {
          comment = "";
        } else {
          comment = comment
            .split("\n")
            .join("<br>")
            .replace(/●/g, "");
        }
        this.textareaapprove = "●";
      }

      let projectID = this.page;

      this.$api
        .post("Project/BatchApproveProject", {
          projectID: [projectID],
          operate: operate,
          comment: comment
        })
        .then(res2 => {
          if (res2.data.status == true) {
            this.middlePageNum = res2.data.content.projectID;
            let content = res2.data.content;
            this.intervalAlert(operate, content);
          } else {
            if (res2.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {
              //console.log("postApproval");
              this.$message({
                type: "error",
                message: res2.data.message
              });
              return false;
            }
          }
          if (operate == 2) {
            this.visibleT = false;
          } else if (operate == 1) {
            this.visibleA = false;
          }
        });
    },
    //倒计时提示
    intervalAlert(operate, content) {
      this.isSp = true;
      this.timeNum = 3;
      this.alertmsg = "Successfully Rejected!";
      if (operate == 1) {
        this.alertmsg = "Successfully Approved!";
      }
      if (!this.timer) {
        this.timer = setInterval(() => {
          if (this.timeNum > 1 && this.timeNum <= 3) {
            //限制倒计时区间
            this.timeNum--;
          } else {
            clearInterval(this.timer); //删除定时器
            this.timer = null;
            this.isSp = false;
            //跳转的页面写在此处
            if (content.projectID == 0) {
              this.$router.push({ path: "/ApprovalIndex/" });
            } else {
              if (content.type == "Closure") {
                this.page = content.projectID;
              } else {
                this.$router.push({
                  name: "Project",
                  params: {
                    ID: content.projectID,
                    isapprove: this.$route.params.isapprove
                  }
                });
              }
            }
          }
        }, 1000);
      } else {
        this.timer.clearTimer();
      }
    },
    //倒计时内按钮参数1表示返回，2表示下一个
    intervalButtom(choice) {
      clearInterval(this.timer); //删除定时器
      this.timer = null;
      this.isSp = false;
      if (choice == 1) {
        this.$router.go(-1);
      } else {
        this.page = this.middlePageNum;
      }
    },
    packclick() {
      this.pack = !this.pack;
      this.$nextTick(() => {
        this.initChart();
      });
    }
  },
  watch: {
    page(val) {
      this.bindData(val);
      this.bindApprovalData(val);
      this.bindApprovalHistoryData(val);
      this.bindClosurePyramidData(val);
      this.bindAttachment(val);
      this.bindApprovalProcess(val);
    },
    url(val) {
      this.getNumPages(val);
    }
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.chartResize();
    });
    this.$nextTick(() => {
      this.page = this.$route.params.ID;
      this.isapprove = this.$route.params.isapprove;
    });
  }
};
</script>
<style scoped lang="scss">
#home {
  height: 100vh;
  width: 100%;
  background: #fbfbfb;
  display: flex;
}

#home .header {
  margin-bottom: 10px;
  padding: 0 24px;
  display: flex;
}

#home .nav-menu {
  width: auto;
  padding-top: 40px;
  background: #27333d;
  position: relative;
}
#home .nav-menu .ssBtn {
  border-radius: 0 38px 38px 0;
  width: 12px;
  height: 76px;
  text-align: center;
  font-size: 12px;
  line-height: 76px;
  position: absolute;
  right: -12px;
  top: 50%;
  cursor: pointer;
  z-index: 10;
  transform: translateY(-38px);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
}
#home .main {
  flex: 1;
}

#home .el-menu {
  border-right: none;
}

#home .el-menu-item {
  padding: 0 !important;
  cursor: default;
}

#home .el-menu-item.is-active {
  color: #eeeeef;
}

#home .el-menu-vertical-demo .icon {
  width: 80px;
}

#home .el-menu-vertical-demo .title {
  width: 207px;
  text-align: left;
  padding: 0 10px;
  height: 58px;
  line-height: 58px;
  border-bottom: 1px solid #424a52;
  border-top: 1px solid #424a52;
  text-indent: 1em;
}

#home .el-menu-vertical-demo .titleFirst {
  border: none;
}

#home .el-menu-item {
  padding: 0;
  display: flex;
}
p {
  margin: 0;
}

div {
  box-sizing: border-box;
}

.wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 0 25px;
  box-sizing: border-box;
  flex-direction: column;
}

.wrapper .dialog {
  width: 500px;
  height: 300px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  z-index: 999;
  position: absolute;
  color: #fff;
  top: 50%;
  right: 50%;
  transform: translate(50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.wrapper .addContent {
  display: flex;
  flex-direction: column;
  text-align: left;
}
.wrapper .dialog .btns {
  display: flex;
  justify-content: space-around;
}

.wrapper .top {
  height: 160px;
  border: 1px solid #979797;
  display: flex;
  box-sizing: border-box;
  padding: 15px 0 15px 0;
  justify-content: space-between;
}

.wrapper .top .process {
  height: 100%;
  flex: 1;
  position: relative;
}

.wrapper .top .process .line {
  width: 91%;
  height: 100%;
  box-sizing: border-box;
  padding-top: 7px;
  position: absolute;
  top: 0;
  left: 5%;
  z-index: 1;
  display: flex;
}
.wrapper .top .process .line ::v-deep .el-progress-bar {
  padding: 0 15px !important;
  margin: 0 !important;
}
.wrapper .el-progress.el-progress--line {
  width: 100%;
}

.wrapper .top .process .points {
  width: 91%;
  height: 100%;
  background: transparent;
  position: absolute;
  top: 0;
  left: 5%;
  z-index: 2;
  display: flex;
  flex-direction: column;
}

.wrapper .top .process .points .pointContent {
  flex: 1;
  display: flex;
  justify-content: space-between;
}

.wrapper .top .process .points .pointContent div {
  display: flex;
  flex-direction: column;
  position: relative;
}

.wrapper .top .process .points .pointContent .txt {
  font-weight: 600;
  position: absolute;
  top: 40px;
  left: -15px;
}

.wrapper .tg {
  width: 16px;
  height: 16px;
  background: #90b407;
  border: 7px solid #d2ec9e;
  border-radius: 15px;
  position: relative;
}

.wrapper .rj {
  width: 16px;
  height: 16px;
  background: #ff4b4b;
  border: 7px solid #fcbfbf;
  border-radius: 15px;
  position: relative;
}

.wrapper .common {
  width: 16px;
  height: 16px;
  border: 7px solid #dddddd;
  border-radius: 15px;
  position: relative;
}

.wrapper .btns {
  margin-top: 15px;
  height: 80px;
  display: flex;
  justify-content: space-between;
}
.wrapper .btnstitle {
  margin-top: 15px;
  height: 15px;
}
.wrapper .btns .left {
  font-size: 28px;
  padding-top: 5px;
  float: left;
}
.wrapper .btns .minleft {
  font-size: 20px;
  padding-top: 12px;
  padding-bottom: 12px;
  float: left;
}
.wrapper .btns .right {
  float: right;
}
.wrapper .btns .right button {
  height: 50px;
  width: 130px;
}
.fontBold {
  font-weight: bold;
}
.fontBoldLine {
  font-weight: bold;
  color: orange;
}

.wrapper .center {
  height: 300px;
  border: 1px solid #979797;
  margin-top: 15px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.wrapper .center #txPic {
  width: 500px;
  height: 100%;
}

.wrapper .center .linePic {
  width: 900px;
  height: 100%;
  display: flex;
  margin-right: 30px;
  align-items: center;
  position: relative;
}

.wrapper .center .linePic .item {
  display: flex;
  /* display: -webkit-box; */
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  position: absolute;
  left: 0;
}

.wrapper .center .title {
  position: absolute;
  top: 10px;
  left: 20px;
  width: 95%;
  font-size: 22px;
  z-index: 4;
  line-height: 22px;
  font-weight: 600;
  color: #080808;
  display: flex;
  text-align: left;
  justify-content: space-between;
}

.wrapper .center .linePic .item img {
  transform: scaleY(0.6);
}

.onePic {
  position: absolute;
  top: -40px;
  right: 20px;
  color: #2c3e50;
  font-size: 16px;
  font-weight: bolder;
}
.onePic span {
  position: absolute;
  left: -88px;
  top: -10px;
}
.twoPic {
  position: absolute;
  bottom: -60px;
  right: 20px;
  color: #2c3e50;
  font-size: 16px;
  font-weight: bolder;
}
.twoPic span {
  position: absolute;
  left: -86px;
  bottom: 15px;
}

.wrapper .table {
  height: 400px;
  display: flex;
  flex-wrap: wrap;
  font-size: 18px;
  font-weight: 500;
  margin-top: 20px;
  border: 1px solid #979797;
  .title {
    height: 49px;
    width: 100%;
    line-height: 50px;
    padding-left: 53px;
    border-bottom: 1px solid #ececec;
    text-align: left;
  }

  .table {
    height: 350px;
    width: 100%;
    padding: 53px;
    box-sizing: border-box;
    .content {
      width: 100%;
      height: 100%;
      border: 1px solid #979797;
      display: flex;
      flex-direction: column;
      .row {
        height: 53px;
        line-height: 53px;
        display: flex;
        border-bottom: 1px solid #979797;
        &:nth-of-type(4) {
          border: 0;
          flex: 1;
        }
      }
    }
  }
  .txt {
    height: 100%;
    text-align: center;
    color: rgb(95, 95, 95);
    width: 158px;
    background: #fee7c5;
    border-right: 1px solid #979797;
    text-align: left;
    padding-left: 10px;
  }
  .val {
    flex: 1;
    display: flex;
    align-items: center;
    line-height: normal;
    padding-left: 16px;
    font-size: 18px;
    font-weight: 500;
    border-right: 1px solid #979797;
    text-align: left;
  }
  p {
    flex: 1;
    display: flex;
  }
}

.wrapper .bottom {
  flex: 1;
  background: #fff;
  margin-top: 15px;
  overflow: hidden;
  filter: progid:DXImageTransform.Microsoft.Shadow(color=#909090, direction=120, strength=4);
  -moz-box-shadow: 2px 2px 10px #909090;
  -webkit-box-shadow: 2px 2px 10px #909090;
  box-shadow: 2px 2px 10px #909090;
}

.wrapper .bottom .img {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.fontbold {
  font-weight: 600;
}
</style>
<style>
.project-table tr td,
.project-table th.is-leaf {
  border-bottom: 1px solid rgb(129 143 165/60%) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Closure.vue